import api from '@/lib/axios';
import type { PaginatedResult } from '@/components/data-table';

export interface NooraniStudentAttendanceRow {
  studentId: string;
  admissionNo: string;
  studentName: string;
  className: string;
  sectionName: string;
  present: number;
  absent: number;
  late: number;
  total: number;
  percentage: number;
}

export interface NooraniTeacherSessionRow {
  id: string;
  groupId: string;
  groupName: string;
  schoolId: string;
  schoolName: string;
  teacherId: string | null;
  teacherName: string | null;
  date: string;
  startTime: string;
  endTime: string | null;
  duration: string | null;
}

export interface NooraniStudentAttendanceParams {
  page?: number;
  limit?: number;
  groupId: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface NooraniTeacherAttendanceParams {
  page?: number;
  limit?: number;
  groupId?: string;
  schoolId?: string;
  date?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface LogNooraniSessionPayload {
  groupId: string;
  teacherId?: string;
  date: string;
  startTime: string;
  endTime?: string;
}

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export const NooraniAttendanceApi = {
  students: async (params: NooraniStudentAttendanceParams): Promise<PaginatedResult<NooraniStudentAttendanceRow>> =>
    unwrap(await api.get('/noorani-attendance/students', { params })),

  teachers: async (params?: NooraniTeacherAttendanceParams): Promise<PaginatedResult<NooraniTeacherSessionRow>> =>
    unwrap(await api.get('/noorani-attendance/teachers', { params })),

  logSession: async (payload: LogNooraniSessionPayload): Promise<NooraniTeacherSessionRow> =>
    unwrap(await api.post('/noorani-attendance/sessions', payload)),

  deleteSession: async (id: string): Promise<{ id: string }> => unwrap(await api.delete(`/noorani-attendance/sessions/${id}`)),
};
